// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidden-features-message {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--primary-color, #007bff);
  color: white;
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  font-size: 14px;
  z-index: 1000;
  animation: fadeInOut 3s ease-in-out;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translate(-50%, 20px);
  }
  15% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  85% {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -20px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/contexts/hidden-features.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF","sourcesContent":[".hidden-features-message {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--primary-color, #007bff);\n  color: white;\n  padding: 8px 16px;\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  z-index: 1000;\n  animation: fadeInOut 3s ease-in-out;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n@keyframes fadeInOut {\n  0% {\n    opacity: 0;\n    transform: translate(-50%, 20px);\n  }\n  15% {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n  85% {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n  100% {\n    opacity: 0;\n    transform: translate(-50%, -20px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
